import PageTabNavigation, { PageTabItem } from 'src/shared/components/navigations/pageTabNavigation';
import { RoutesEnum } from 'src/shared/models/enums/routes.enum';

export const SwishTabNavigation = () => {
  const pageTabs: PageTabItem[] = [
    {
      label: 'invoice:swishStatus.tabConsents',
      route: RoutesEnum.SwishConsents,
    },
    {
      label: 'invoice:swishStatus.tabMembers',
      route: RoutesEnum.MemberSwishStatus,
    },
  ];

  return <PageTabNavigation pageTabs={pageTabs} />;
};
